import React, { FC } from "react";
import moment from "moment";
import { Logs as LogsStyled } from "./elements";
import { Log } from "../../../core/entities/log";

type Props = {
  logs: {
    id: string;
    logs: Log[];
  };
};

const Logs: FC<Props> = ({ logs }) => {
  return (
    <div>
      <LogsStyled>
        <ul>
          {logs.logs.map((log: Log, index: number) => (
            <li key={index}>
              {log.editor
                ? `${log.status} by ${log.editor} on ${moment(
                    log.dateTime
                  ).format("MM/DD/YY hh:mma")}`
                : `Applicant applied on ${moment(log.dateTime).format(
                    "MM/DD/YY hh:mma"
                  )}`}
            </li>
          ))}
        </ul>
      </LogsStyled>
    </div>
  );
};

export default Logs;
